import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { GridUtils } from "../../utils/gridUtils";
import {
  setAdvancedFilterQuery,
  setSimpleFilterQuery,
} from "../../utils/tableUtils";
import { AppSessionService } from "../app-session/app-session.service";

const EMPTY_STRING = "";
@Injectable({
  providedIn: "root",
})
export class ServiceModeService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  getServiceModes(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }
    return this.http.get(
      this.buildDataUrl(paging, filteringArgs, sortingArgs, headers, "?"),
      { headers }
    );
  }

  getServiceMode(code): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.appSession.baseUrl + "/api/v1/serviceMode"}/${code}`;
    return this.http.get(url, { headers });
  }

  createServiceMode(action): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(action.serviceMode);
    const url = `${this.appSession.baseUrl + "/api/v1/serviceMode"}`;
    return this.http.post(url, data, { headers });
  }

  updateServiceMode(serviceMode): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(serviceMode);
    const url = `${this.appSession.baseUrl + "/api/v1/serviceMode"}/${
      serviceMode?.code
    }`;
    return this.http.put(url, data, { headers });
  }

  private buildDataUrl(
    pagingArgs: any,
    filteringArgs: any,
    sortingArgs: any,
    header: HttpHeaders,
    path: string
  ): string {
    let baseQueryString = `${
      this.appSession.baseUrl + "/api/v1/serviceMode"
    }${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }
}
